export default "<!--\r\n<div [chart]=\"chart\"  id=\"container\"></div>\r\n\r\n<div id=\"container1\"></div>\r\n-->\r\n";